//region block: pre-declaration
//endregion
function toJsArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
//region block: exports
export {
  toByteArray as toByteArray18j13y992cujz,
  toJsArray as toJsArray19cldvndk6qr4,
};
//endregion

//# sourceMappingURL=TargetUtilsJs.mjs.map
